import styles from './app.module.scss';
import Toast from "../Toast/Toast";
import { SnackbarProvider } from 'notistack';
import { useLocation } from 'react-router';
import Footer from '../Footer';
import RefreshTokenCitroen from '../../containers/RefreshTokenCitroenContainer';
import NavBar from '../../layout/navBar';
import Routes from '../../routes/Routes';
import { useEffect, useState } from 'react';
import { checkPopupBlocker } from '../../helpers/functions';

const App = () => {
	const location = useLocation();
	const [havePermissionPopUp, setHavePermissionPopUp] = useState<boolean>(true);

	useEffect(() => {
		setTimeout(() => {
			const isLocked = checkPopupBlocker();
			setHavePermissionPopUp(isLocked);
		},700)
	
	},[])

	return (
		<SnackbarProvider content={(key, message) => <Toast id={key} content={message} />}>
			<RefreshTokenCitroen/>
			<div className={styles.app}>
				{
					(location.pathname !== "/contact")  && 
					<NavBar />
				}
				<Routes />
			</div>
			{["/buy/customization/discover","/buy/paymentStepper","/buy/paymentStepper/reserve"].includes(location.pathname) ? null :  <Footer/>}
		</SnackbarProvider>
	);
}

export default App;
